import React from "react";
import Home from "../public/Home";

export default function HomePatient() {
    return (
        <>
            <Home roleUser={'Patient'} />
        </>
    )
}